import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import React, { useEffect, useState, useRef } from "react";
import { Link, useParams } from "react-router-dom";
//import { useForm } from "react-hook-form";

import moment from "moment-timezone";
import TimeAgo from "react-timeago";
import { connect, useDispatch } from "react-redux";
import ResourceAPI from "../../api/resourceAPI";
import CollectionAPI from "../../api/collectionAPI";
import FileAPI from "../../api/fileAPI";
import UserAPI from "../../api/userAPI";

import ResourceFiles from "../../components/Resource/Files";
import PreviewImage from "../../components/Resource/PreviewImage";
import AuthLayout from "../../components/AuthLayout/AuthLayout";

import { setMessage } from "../../redux/actions/message";

import format from "../../helpers/format";
import { MEDIA_URL, FE_WEBSITE_URL } from "../../configs";
dayjs.extend(relativeTime);

//export default function ResourceDetail(props) {
function ResourceDetail(props) {
  const { id } = useParams();

  //copy text state
  const textSlugRef = useRef(null);
  const [copySuccess, setCopySuccess] = useState("");

  const [isLoading, setLoading] = useState(true);
  const [resource, setResource] = useState([]);
  const [notFound, setNotFound] = useState(false);
  const [resourceFiles, setResourceFiles] = useState([]);
  const [rejectionReason, setRejectionReason] = useState({});
  const [rejectByUser, setRejectByUser] = useState({});
  const [collections, setCollections] = useState([]);
  const [similarResources, setSimilarResources] = useState([]);
  const dispatch = useDispatch();
  const { token, user, message, messageType } = props;

  const [show, toggleShow] = useState(true);
  const [descCollapsed, setDescCollapsed] = useState(true);

  // This is the function we wrote earlier
  function copyTextToClipboard(text) {
    if ("clipboard" in navigator) {
      return navigator.clipboard.writeText(text);
    } else {
      return document.execCommand("copy", true, text);
    }
  }

  function copyToClipboard(e) {
    let txt = textSlugRef.current.innerText;
    if ("clipboard" in navigator) {
      navigator.clipboard.writeText(txt);
    } else {
      document.execCommand("copy", true, txt);
    }
    // This is just personal preference.
    // I prefer to not show the whole text area selected.
    //e.target.focus();
    setCopySuccess("Copied!");
  }

  // fetch resource data
  const fetchData = async (id) => {
    try {
      const { data } = await ResourceAPI.getResourceById(id);
      if (!data || Object.keys(data).length === 0) {
        setNotFound(true);
        setResource([]);
        setLoading(false);
        return;
      }
      if (data.status === "reject") {
        const { data: rejection } = await ResourceAPI.getRejectionReasonById(id);
        const reject_by = await UserAPI.getUser(rejection.rejected_by);
        setRejectionReason(rejection);
        setRejectByUser(reject_by);
      }
      setResource(data);
      setNotFound(false);
    } catch (error) {
      setNotFound(true);
      setResource([]);
    }
    setLoading(false);
  };

  /**
   * get resources has same collection
   * @param {str} resourceId
   */

  const getSimilarResources = async (resourceId) => {
    await ResourceAPI.getSameCollectionbyResourceId(resourceId)
      .then((response) => {
        setSimilarResources(response.data);
      })
      .catch((e) => {
      });
  };

  /**
   * get resources has same collection
   * @param {str} resourceId
   */

  const getCollectionByResource = async (resourceId) => {
    await CollectionAPI.getCollectionHasResource(resourceId)
      .then((response) => {
        setCollections(response.data);
      })
      .catch((e) => {
      });
  };

  /**
   * generate resource color base preview
   * @param {str} resourceId
   */
  const generateThumbnail = async (resourceId) => {
    await ResourceAPI.generateResourceThumbnail(resourceId)
      .then((response) => {
        // Use response.data.detail for success message
        dispatch(setMessage({ message: response.data.detail, messageType: "success" }));

      })
      .catch((e) => {
        dispatch(setMessage(`${e}`, "danger"));
      });
  };

  /**
   * generate resource missing data
   * @param {str} resourceId
   */
  const reGenerateData = async (resourceId) => {
    await ResourceAPI.generateResourceData(resourceId)
      .then((response) => {
        dispatch(setMessage(`${response.data}`, "success"));
      })
      .catch((e) => {
        dispatch(setMessage(`${e}`, "danger"));
      });
  };

  /**
   * generate resource color base preview
   * @param {str} resourceId
   */
  const generateColors = async (resourceId) => {
    setLoading(true);
    await ResourceAPI.generateResourceColors(resourceId)
      .then((response) => {
        dispatch(setMessage(`${response.data}`, "success"));
        setLoading(false);
      })
      .catch((e) => {
        dispatch(setMessage(`${e}`, "danger"));
        setLoading(false);
      });
  };

  const fetchFiles = async (resourceId) => {
    await FileAPI.getResourceFiles(resourceId)
      .then((response) => {
        setResourceFiles(response.data);
      })
      .catch((e) => {
      });
  };

  useEffect(() => {
    (async () => {
      await fetchData(id);
      await fetchFiles(id);
      await getSimilarResources(id);
      await getCollectionByResource(id);
    })();
  }, [id]);

  return (
    <AuthLayout>
      {isLoading ? (
        <>
          <p>loading</p>
        </>
      ) : notFound ? (
        <div className="alert alert-danger my-5" role="alert">
          Resource not found or has been deleted.
        </div>
      ) : (
        <>
          <header
            className={
              "d-md-flex d-sm-inline justify-content-between align-items-center mb-4 gap-3"
            }
          >
            <div className="d-flex align-items-center">
              <h2 className="mb-2 me-2 fs-5">{resource.name}</h2>
              <small className="rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal px-2">
                {resource.slug?.split("-").pop()}
              </small>
            </div>
            <div className="text-right d-flex gap-2">
              <Link
                className={"btn btn-primary"}
                to={`/resources/edit/${resource._id}`}
              >
                Edit
              </Link>
              <button
                className={"btn btn-outline-primary text-nowrap"}
                onClick={() => {
                  reGenerateData(resource._id);
                }}
              >
                Generate data
              </button>
              <button
                className={"btn btn-outline-danger text-nowrap"}
                onClick={async () => {
                  const confirmed = window.confirm(
                    `Are you sure you want to delete this resource?\n\nThis will mark the resource as deleted and remove it from listings.\n\nThis action cannot be undone.`
                  );
                  if (!confirmed) return;
                  try {
                    await ResourceAPI.removeResource(resource._id);
                    dispatch(setMessage("Resource deleted successfully", 'success'));
                  } catch (err) {
                    alert("Failed to delete resource: " + (err?.response?.data?.detail || err.message));
                  }
                }}
                style={{ marginLeft: '4px' }}
              >
                Delete Resource
              </button>
              <Link
                to={`/resources/convert-file/?resources_id=${resource._id}`}
                className="btn btn-secondary"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-arrow-left-right"></i>
              </Link>
              <Link
                to={`/resources/similar?resource_id=${resource._id}`}
                className="btn btn-secondary"
                target="_blank"
                rel="noreferrer"
              >
                <i className="bi bi-search"></i>
              </Link>
              
            </div>
          </header>
          {message && (
            <div className="mb-4">
              <div className={`alert alert-${messageType}`} role="alert">
                {message}
              </div>
            </div>
          )}
          <div className="row gx-5">
            <div className="col-md-6">
              <dl className="row gx-3">
                <dt className="col-sm-2 fw-normal text-muted mb-3">Statistic</dt>
                <dd className="col-sm-4">
                  <span className="text-muted me-4" key="viewCount">
                    <i className="bi bi-eye me-1"></i>
                    <span className="small">{resource.viewCount ? resource.viewCount : 0}</span>
                  </span>
                  <span className="text-muted me-4" key="downloadCount">
                    <i className="bi bi-download me-1"></i>
                    <span className="small">{resource.downloadCount ? resource.downloadCount : 0}</span>
                  </span>
                  
                  <span className="text-muted me-4" key="shareCount">
                    <i className="bi bi-share me-1"></i>
                    <span className="small">{resource.shareCount ? resource.shareCount : 0}</span>
                  </span>
                  <span className="text-muted me-4" key="likeCount">
                    <i className="bi bi-heart me-1"></i>
                    <span className="small">{resource.likeCount ? resource.likeCount : 0}</span>
                  </span>
                </dd>
                <dt className="col-sm-2 fw-normal text-muted mb-3">Status</dt>
                <dd className="col-sm-4">
                  <span className="text-capitalize">{format.formatResourceStatus(resource.status)}</span>
                    {resource.status === 'schedule' && resource.scheduled_at && (
                      <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                          <i className="bi bi-clock me-1"></i>
                          <span className="">
                            <TimeAgo date={resource.scheduled_at} />
                          </span>
                      </span>
                    )}
                  {
                    resource.status == 'reject' && rejectionReason &&
                    <span className="mx-3 text-normal text-danger">
                      {rejectionReason.rejection_reason}
                    </span>
                  }
                </dd>
                {resource.status === "schedule" && 
                    <>
                      <dt className="col-sm-2 fw-normal text-muted mb-3">Scheduled at</dt>
                      <dd className="col-sm-4">
                        <span>
                          {dayjs(resource.scheduled_at).format("YYYY-MM-DD HH:mm:ss")}
                        </span>
                        {/* </Moment> */}                     
                        <span className="ms-2 text-normal text-muted">{Intl.DateTimeFormat().resolvedOptions().timeZone}</span>
                      </dd>
                    </>
                }
                {resource.license && (
                  <>
                <dt className="col-sm-2 fw-normal text-muted mb-3">License</dt>
                <dd className="col-sm-4 small">
                  <span
                    className={
                      resource.license && resource.license.toLowerCase() === 'premium'
                        ? 'badge rounded-pill bg-success bg-opacity-10 text-success fw-normal py-1 px-2'
                        : 'badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2'
                    }
                  >
                    {resource.license.toUpperCase()}
                  </span>
                </dd>
                  </>
                )}
                {resource.price && parseInt(resource.price) !== 0 ? (
                  <>
                  <dt className="col-sm-2 fw-normal text-muted mb-3">Price</dt>
                  <dd className="col-sm-4 small">
                    <span>
                      {resource.price}
                    </span>
                  </dd>
                  </>
                ):('')}
                <dt className="col-sm-2 fw-normal text-muted mb-3">Picked</dt>
                <dd className="col-sm-4 small">
                  {resource.is_picked ? (
                    <span className="badge rounded-pill bg-success bg-opacity-10 text-secondary fw-normal py-0 px-2">
                      <i className="small bi bi-check fs-6 text-success"></i>
                    </span>
                  ) : (
                    // <span className="badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-0 px-2">
                     <i className="small text-muted bi bi-ban"></i>
                    // </span>
                  )}
                </dd>
                {resource.contentType && (
                  <>
                <dt className="col-sm-2 fw-normal text-muted mb-3">Type</dt>
                <dd className="col-sm-4 text-capitalize small">
                  <span className="badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    {resource.contentType.toUpperCase()}
                  </span>
                </dd>
                </>
                )}
                {resource.creator && resource.creator.email && (
                  <>
                <dt className="col-sm-2 fw-normal text-muted mb-3">Creator</dt>
                <dd className="col-sm-9">
                  {resource.creator.email}
                  <a
                    target="_blank"
                    rel="noreferrer"
                    href={`/resources/?created_by=${resource.creator.username}`}
                    className="p-1 text-muted d-inline-flex"
                  >
                    <i className="bi bi-grid"></i>
                  </a>
                </dd>
                </>
                )}
                <dt className="col-sm-2 fw-normal text-muted mb-3">Created</dt>
                <dd className="col-sm-4">
                  {dayjs(resource.created_at).format("YYYY-MM-DD HH:mm:ss")}
                  <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                    <i className="bi bi-clock me-1"></i>
                    <span className="">
                      <TimeAgo date={resource.created_at} />
                    </span>
                  </span>
                  {/* {new Date(resource.created_at).toDateString()} */}
                </dd>
                <dt className="col-sm-2 fw-normal text-muted mb-3">
                  Last Update
                </dt>
                <dd className="col-sm-4">
                  {resource.updated_at && (
                    <>
                      {dayjs(resource.updated_at).format("YYYY-MM-DD HH:mm:ss")}
                      <span className="ms-2 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2">
                        <i className="bi bi-clock me-1"></i>
                        <span className="">
                          {dayjs(resource.updated_at).fromNow()}
                        </span>
                      </span>
                    </>
                  )}
                </dd>
                
                <dt className="col-sm-2 fw-normal text-muted mb-3">
                  Orientation
                </dt>
                <dd className="col-sm-4">
                  {resource.orientation && (
                    <>
                      {format.formatResourceOrientation(
                        resource.orientation,
                        true
                      )}
                    </>
                  )}
                </dd>

                <dt className="col-sm-2 fw-normal text-muted mb-3">Colors</dt>
                <dd className="col-sm-2 fw-normal d-flex align-items-center">
                  {Array.isArray(resource.colors) && resource.colors.length > 0 ? (
                    resource.colors.map((color, colorIndex) => {
                      const hexColor = `${((1 << 24) + (color[0] << 16) + (color[1] << 8) + color[2])
                        .toString(16)
                        .slice(1)}`; // Convert RGB to HEX
                      return (
                        <div
                          key={colorIndex + 1}
                          style={{
                            backgroundColor: `rgb(${color[0]},${color[1]},${color[2]})`,
                            width: "30px",
                            height: "15px",
                            cursor: "pointer",
                          }}
                          title={`Click to copy ${hexColor}`}
                          onClick={() => {
                            navigator.clipboard.writeText(hexColor);
                            alert(`Copied ${hexColor} to clipboard!`);
                          }}
                        ></div>
                      );
                    })
                  ) : (
                    <span className="badge bg-danger border-secondary rounded-circle p-0 me-2" style={{ width: 8, height: 8, display: 'inline', verticalAlign: 'middle' }} title="No colors"> 
                    </span>
                  )}
                  <button
                    className="btn btn-sm ms-2"
                    onClick={() => {
                      generateColors(resource._id);
                    }}
                  >
                    <i className="bi bi-palette-fill text-muted"></i>
                  </button>
                </dd>
                
                {/* <dt className="col-sm-2 fw-normal text-muted mb-3">
                  Categories
                </dt>
                <dd className="col-sm-10">
                  {resource.categories &&
                    resource.categories.length > 0 &&
                    resource.categories.map((category, i) => {
                      return (
                        <span className="text-muted" key={i}>
                          {category.name}
                          {i < resource.categories.length - 1 && ","}
                        </span>
                      );
                    })}
                </dd> */}
                <dt className="col-sm-2 fw-normal text-muted mb-3">Styles</dt>
                <dd className="col-sm-4">
                  {resource.styles &&
                    resource.styles.length > 0 &&
                    resource.styles.map((style, i) => {
                      return (
                        <span className="text-muted" key={i}>
                          {style}
                          {i < resource.styles.length - 1 && ","}
                        </span>
                      );
                    })}
                </dd>
                
              </dl>
              <dl className="row mb-5 gx-3">
                <dt className="col-sm-2 fw-normal text-muted mb-3">
                  Description
                </dt>
                <dd className="col-sm-9 mb-2">
                  <div
                    className="rdesc-view desc-fixed-height position-relative"
                    style={{
                      maxHeight: descCollapsed ? 100 : 'none',
                      overflow: descCollapsed ? 'hidden' : 'visible',
                      transition: 'max-height 0.3s',
                      paddingRight: 40,
                    }}
                  >
                    {resource.description ? (
                      <span dangerouslySetInnerHTML={{ __html: resource.description }} />
                    ) : null}
                    {resource.description && resource.description.length > 200 && (
                      <div
                        style={{
                          position: 'absolute',
                          right: 0,
                          bottom: 0,
                          background: 'linear-gradient(90deg, transparent 0%, #fff 80%)',
                          width: descCollapsed ? '100%' : 'auto',
                          height: descCollapsed ? 40 : 0,
                          display: descCollapsed ? 'block' : 'none',
                        }}
                      />
                    )}
                  </div>
                  {resource.description && resource.description.length > 200 && (
                    <button
                      className={`btn ${descCollapsed ? 'btn-light' : 'btn-secondary'} btn-sm px-2 mt-1`}
                      style={{ fontSize: 13 }}
                      onClick={() => setDescCollapsed((prev) => !prev)}
                    >
                      {descCollapsed ? (
                        <i className="bi bi-chevron-down"></i>
                      ) : (
                        <i className="bi bi-chevron-up"></i>
                      )}
                    </button>
                  )}
                </dd>
                <dt className="col-sm-2 fw-normal text-muted mb-3">Tags</dt>
                <dd className="col-sm-9">
                  {resource.tags &&
                    resource.tags.length > 0 &&
                    resource.tags.map((tag, i) => {
                      return (
                        <span
                          className="badge rounded bg-light small rounded me-2 text-dark fw-normal fs-6 my-1 py-1 px-3 suggested-tag"
                          key={i}
                        >
                          {tag.name}
                          {/* {i < resource.tags.length - 1 && ','} */}
                        </span>
                      );
                    })}
                </dd>
              </dl>
              {resource.metaSeo && (
                <>
                  <p className="mb-4">
                    <strong>Meta SEO</strong>
                  </p>
                  
                  <dl className="row mb-5 gx-3">
                    <dt className="col-sm-2 fw-normal text-muted mb-3">Slug</dt>
                    <dd className="col-sm-9">
                      <span ref={textSlugRef}>{resource.slug}</span>
                      {/* <input name="slug" type="text" className="d-none" value={resource.slug} ref={textSlugRef} /> */}
                      <a
                        target="_blank"
                        rel="noreferrer"
                        href={`${FE_WEBSITE_URL}vector/${resource.slug}`}
                        className="ms-4 me-1 small px-2 py-1 text-muted btn btn-link"
                      >
                        <i className="bi bi-link fs-5"></i>
                      </a>
                      <span
                        className="mx-1 px-2 py-1 small text-muted btn btn-link"
                        onClick={copyToClipboard}
                      >
                        {!copySuccess ? (
                          <i className="bi bi-clipboard fs-6"></i>
                        ) : (
                          <>
                            <i className="bi bi-check text-success fs-6"></i>
                            <span className="ms-2">{copySuccess}</span>
                          </>
                        )}
                      </span>
                    </dd>
                    <dt className="col-sm-2 fw-normal text-muted mb-3">
                      Canonical
                    </dt>
                    <dd className="col-sm-9 mb-2">
                      {resource.metaSeo && resource.metaSeo.canonicalURL
                        ? resource.metaSeo.canonicalURL
                        : ""}
                    </dd>
                    <dt className="col-sm-2 fw-normal text-muted mb-3">
                      Keyword
                    </dt>
                    <dd className="col-sm-9 mb-2">
                      {resource.metaSeo && resource.metaSeo.metaKeywords
                        ? resource.metaSeo.metaKeywords
                        : ""}
                    </dd>
                    <dt className="col-sm-2 fw-normal text-muted mb-3">
                      Title
                    </dt>
                    <dd className="col-sm-9 mb-2">
                      {resource.metaSeo && resource.metaSeo.metaTitle
                        ? resource.metaSeo.metaTitle
                        : ""}
                    </dd>
                    <dt className="col-sm-2 fw-normal text-muted mb-3">
                      Description
                    </dt>
                    <dd className="col-sm-9 mb-2">
                      {resource.metaSeo && resource.metaSeo.metaDescription
                        ? resource.metaSeo.metaDescription
                        : ""}
                    </dd>
                  </dl>
                </>
              )}

              {resourceFiles && (
                <>
                  <h6 className="mb-4">Other files from same resources</h6>
                  <ResourceFiles resourceFiles={resourceFiles} />
                </>
              )}
              {/* collection */}
              {collections && collections.length > 0 && (
                <>
                  <h6 className="mt-8 pt-4 pb-2">
                    {"Collections with resource"}
                  </h6>
                </>
              )}
              {collections &&
                collections.map((collection, colIndex) => {
                  return (
                    <div
                      key={colIndex}
                      className="mb-3 d-flex justify-content-start align-items-center"
                    >
                      <div className="me-4 text-muted p-2">
                        <i className="bi bi-collection fs-5"></i>
                      </div>
                      <div className="me-4">
                        <p className="mb-1">
                          <Link to={`/collections/view/${collection._id}`}>
                            {collection.collection_name}
                          </Link>
                        </p>
                        <p>
                          <small className="rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal px-2 py-1">
                            {collection.owner.email}
                          </small>
                          <span className="small rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal px-2 ms-1 py-1">
                            {dayjs(collection.created_at).format("YYYY-MM-DD")}
                          </span>
                        </p>
                      </div>
                    </div>
                  );
                })}
            </div>
            <div className="col-md-6 py-4 text-left">
              {resource.images && resource.images.length > 0 && (
                <div className="bg-gray">
                  {resource.images.map((preview, index) => {
                    return (
                      <div className="text-center" key={index}>
                        <div className="bg-secondary bg-opacity-10 rounded-4 mx-2 position-relative">
                          <PreviewImage
                            image={`${MEDIA_URL}${preview.sizes[0].path}`}
                            index={index}
                            width={400}
                            disable={true}
                          />

                          {/* {mainImage !== index && (
                            <button
                              type="button"
                              className="position-absolute top-0 end-0 border-0 bg-transparent"
                              onClick={() => removePreview(preview.filename)}
                            >
                              <i className="bi bi-x-circle-fill"></i>
                            </button>
                          )} */}
                        </div>
                        {resource.mainImage === index && (
                          <span className="pt-2 fw-semibold me-2">
                            <small className="badge bg-success rounded-pill text-uppercase">
                              C
                            </small>
                          </span>
                        )}
                        <span className="me-2 mt-1 badge rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal py-1 px-2 text-uppercase">
                          {preview.sizes[0].contentType}
                        </span>
                        {preview.sizes[0] && (
                          <>
                            <div className="badge bg-secondary bg-opacity-10 text-secondary rounded-pill fw-normal pt-1 text-uppercase small mx-1 my-2">
                              {preview.sizes[0].width +
                                " x " +
                                preview.sizes[0].height}
                            </div>
                          </>
                        )}
                        {preview.sizes[1] &&
                          preview.sizes[1].size === "small" && (
                            <a
                              href={`${MEDIA_URL}${preview.sizes[1].path}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              <div className="badge bg-secondary bg-opacity-10 text-secondary rounded-pill fw-normal pt-1 text-uppercase small mx-1 my-2">
                                {preview.sizes[1].width +
                                  " x " +
                                  preview.sizes[1].height}
                              </div>
                            </a>
                          )}
                        
                        <div className="d-flex justify-content-center align-items-center mt-1 mb-3">
                        {resource?.images?.length > 0 && (
                        <div className="text-center">
                          <button
                            className="btn btn-sm bg-light"
                            onClick={() => {
                              // generateColors(resource._id);
                              generateThumbnail(resource._id);
                            }}
                          >
                            <span className="small text-muted ms-3">
                              Generate thumbnails
                            </span>
                          </button>
                        </div>
                        )}
                        <a className="btn btn-sm bg-light ms-2" href={`https://lens.google.com/uploadbyurl?url=https://media.magipik.com/${preview.sizes[0].path}`} target="_blank" rel="noreferrer">
                          <span className="small text-muted">Google Image</span>
                        </a>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
              {/* {resource.images &&
                resource.images.map((preview, p) => {
                  return (
                    <div className="w-auto bg-light p-4" key={p}>
                      <PreviewImage
                        image={`${MEDIA_URL}${preview.sizes[0].path}`}
                        width={480}
                      />
                    </div>
                  );
                })} */}
              
              <div>
                {similarResources && similarResources.length > 0 && (
                  <div className="d-flex justify-content-between align-items-center">
                    <h6 className="mt-8 pt-4 pb-2">
                      {`Resources with same name or collection`}
                      <span className="small fw-normal text-muted">{` ( ${similarResources.length} resources )`}</span>
                    </h6>
                    {/* <button
                      onClick={() => toggleShow(!show)}
                      className="btn btn-sm btn-light"
                    >
                      {show ? "hide" : "show"}
                    </button> */}

                    <button
                      className={`btn ${show ? 'btn-light' : 'btn-secondary'} btn-sm px-2 mt-1`}
                      style={{ fontSize: 13 }}
                      onClick={() => toggleShow(!show)}
                    >
                      {show ? (
                        <i className="bi bi-chevron-down"></i>
                      ) : (
                        <i className="bi bi-chevron-up"></i>
                      )}
                    </button>
                  </div>
                )}
                {show && (
                  <>
                    {similarResources &&
                      similarResources.map((resource, index) => {
                        return (
                          <div
                            className="d-flex shadow-sm rounded-4 align-items-center justify-content-between mb-4 px-4 border-0 border-end-1"
                            key={index}
                          >
                            <div className="d-flex justify-content-start text-left align-items-center">
                              {resource?.thumbnail && resource._id && (
                                <div className="me-4">
                                  <Link to={`/resources/view/${resource._id}`} tabIndex={0}>
                                    <img
                                      src={`${MEDIA_URL}${resource?.thumbnail?.path}`}
                                      height={48}
                                      className="mx-auto my-2 img-fluid px-8 small-thumb"
                                      alt={resource.name || 'Resource thumbnail'}
                                    />
                                  </Link>
                                </div>
                              )}
                              <div>
                                <p className="mb-1 list-title">
                                  {resource._id ? (
                                    <Link
                                      to={`/resources/view/${resource._id}`}
                                      className="text-dark"
                                      tabIndex={0}
                                    >
                                      {resource.name || 'Untitled Resource'}
                                    </Link>
                                  ) : (
                                    <span className="text-muted">{resource.name || 'Untitled Resource'}</span>
                                  )}
                                </p>
                                <p className="mb-1 small">
                                  {format.formatResourceStatusNoText(
                                    resource.status
                                  )}
                                  <small className="rounded-pill bg-secondary bg-opacity-10 text-secondary fw-normal px-2 py-1 ms-2">
                                    {resource.slug.split("-").pop()}
                                  </small>
                                  {resource.metaSeo &&
                                  resource.metaSeo.canonicalURL ? (
                                    <>
                                      <small className="badge bg-primary rounded-pill ms-2">
                                        {"C"}
                                      </small>
                                      <small className="badge bg-light ms-1 text-dark">
                                        {resource.metaSeo.canonicalURL
                                          .split("-")
                                          .pop()}
                                      </small>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                  {resource.metaSeo &&
                                  resource.metaSeo.redirectURL ? (
                                    <>
                                      <span className="badge small bg-danger rounded-pill ms-2">
                                        {"R"}
                                      </span>
                                      <span className="badge small bg-light ms-1 text-dark">
                                        {resource.metaSeo.redirectURL
                                          .split("-")
                                          .pop()}
                                      </span>
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </p>
                              </div>
                            </div>
                            <div className="text-end">
                              <Link
                                to={`/resources/edit/${resource._id}`}
                                className=""
                              >
                                <i className="bi bi-pencil text-muted"></i>
                              </Link>
                            </div>
                          </div>
                        );
                      })}
                  </>
                )}
              </div>
            </div>
          </div>
          {/* end html row*/}
        </>
      )}
    </AuthLayout>
  );
}

function mapStateToProps(state) {
  const { token } = state.auth;

  const { message, messageType } = state.message;
  return {
    token,
    message,
    messageType,
  };
}

export default connect(mapStateToProps)(ResourceDetail);
